"use client"

import { FloatingActionButtons } from "@/components/FloatingActionButtons"
import { Footer } from "@/components/Footer"
import { MyHeader } from "@/components/sections/MyHeader"
import { My } from "@/components/sections"

const Home = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-black transition-colors duration-300">
      {/* Header */}
      <MyHeader />

      {/* Main Content */}
      <main className="pt-20 pb-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Hero Section */}
          <section id="about" aria-label="About Amit Dhoju" className="mb-20 scroll-mt-20">
            <My.Hero />
          </section>

          {/* Overview Section */}
          {/* <section aria-label="Professional Overview" className="mb-20">
            <My.Overview />
          </section> */}

          {/* Skills Section */}
          <section id="skills" aria-label="Technical Skills" className="mb-20 scroll-mt-20">
            <My.Skill />
          </section>

          {/* Experience Section */}
          <section id="experience" aria-label="Professional Experience" className="mb-20 scroll-mt-20">
            <My.Experience />
          </section>

          {/* Education Section */}
          <section id="education" aria-label="Education" className="mb-20 scroll-mt-20">
            <My.Education />
          </section>

          {/* Projects Section */}
          <section id="projects" aria-label="Projects" className="mb-20 scroll-mt-20">
            <My.Projects />
          </section>

          {/* Contact Section */}
          <section id="contact" aria-label="Contact" className="scroll-mt-20">
            <My.ContactForm />
          </section>

          {/* Google Maps Section */}
          <section id="location" aria-label="Location" className="scroll-mt-20">
            <My.Location />
          </section>
        </div>
      </main>

      <Footer />

      <FloatingActionButtons />
    </div>
  )
}

export default Home
